<sc-flex vertical fitHeight stretchContent>
  <sc-dialog-title>
    <sc-dictionary-label dictionaryKey="tmc-yard.truck-search.common.title"></sc-dictionary-label>
  </sc-dialog-title>
  <sc-padding [formGroup]="formGroup" noFieldSpace leftRightOnly>
    <sc-flex>
      <sc-flex-fitting-content>
        <sc-string-field formControlName="query" labelDictionaryKey="tmc-yard.admin.ui.truck-group.query">
        </sc-string-field>
      </sc-flex-fitting-content>
      <sc-padding>
        <sc-action-icon [disabled]="!searchEnabled" (click)="searchTruck()"
          iconClass="fa-magnifying-glass"></sc-action-icon>
      </sc-padding>
    </sc-flex>
  </sc-padding>
  <sc-content-spacer vertical></sc-content-spacer>
  <sc-flex-fitting-content vertical>
    <sc-padding leftRightOnly>
      <sc-scroll-pane>
        <app-truck [truck]="truck" [selected]="selectedTruck" (click)="onSelect(truck)"
          *ngFor="let truck of foundTrucks"></app-truck>
      </sc-scroll-pane>
    </sc-padding>
  </sc-flex-fitting-content>
  <sc-padding>
    <sc-flex>
      <sc-content-spacer grow></sc-content-spacer>
      <sc-cancel-button (click)="onCancel()"></sc-cancel-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-confirm-button primary [disabled]="selectedTruck == null" (click)="onConfirm()"></sc-confirm-button>
    </sc-flex>
  </sc-padding>
</sc-flex>
